<script>
  export let item;
  export let moderator;
  export let jumptoEventsPageTermin;

  const typLabels = { 1: ["Workshop", "ws"], 2: ["Gruppen- gespräch", "gg"], 3: ["OneToOne", "oo"] };
  $: typLabel = typLabels[item.typ];
  $: isImSpezial = [7, 8, 9, 10, 11, 12].includes(item.typ);

  const [hours, minutes] = item.startTime.split(":").map(Number);
  const offsetMinutes = (hours - 8) * 60 + minutes;
  const timeblockStyle = `position: absolute; top: ${offsetMinutes * 3}px; height: 150px; cursor: pointer;`;

  function startJumptoEventsDetails() {
    const targetName = item.terminId > 0
      ? `termin_${item.terminId}`
      : item.veranstaltungId > 0
        ? `v_${item.veranstaltungId}`
        : "";
    jumptoEventsPageTermin(targetName);
  }
</script>

<button class="not-prose left-[2%] w-[46%] text-left flex border border-solid rounded-md border-gray-400/50 bg-im-signal p-3 text-white drop-shadow-md" on:click={startJumptoEventsDetails} style={timeblockStyle}>
<div class="flex flex-col gap-1">
  <div class="flex items-center mb-1">
    <img class="mr-2 h-5" src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/ico_{typLabel[1]}_white.gif" alt={typLabel[0]} title={typLabel[0]} />
   <span class="text-white text-sm font-bold whitespace-pre-wrap">{typLabel[0]}</span>
  </div>
  <!-- <img class="h-3 mr-2" src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/icon/icon_clock.svg" alt="clock"/> -->
  <span class="text-xs">{item.startTime} - {item.endTime}</span>
  <span class="text-xs">{isNaN(item.location) ? 'Raum' : 'Saal'} {item.location}</span>
  {#if moderator}<span class="text-xxs">Moderator</span>{/if}
  {#if isImSpezial}
  <div class="flex flex-col">
    <span class="text-xs">IM Spezial</span>
    <span class="text-xs"> {item.referent1name}</span>
  </div>
  {/if}
  </div>
</button>
